import { createSlice } from '@reduxjs/toolkit';
import { get_initial_ui_settings } from 'console/redux/settings-actions';
const slice = createSlice({
    name: 'map_dashboard',
    initialState: () => {
        const { map_dashboard_active } = get_initial_ui_settings(window.PRELOAD);
        return map_dashboard_active ?? false;
    },
    reducers: {
        activeMapDashboard: (state) => true,
        exitMapDashboard: (state) => false,
    },
});
export const { activeMapDashboard, exitMapDashboard } = slice.actions;
export const mapDashboardReducer = slice.reducer;
